import {soundSprites} from "./soundSprites";
import {isMuted, isTouched, sounds} from "./index";
import {trackError} from "../../store/log/actions";
import { getStore } from "../..";

export default function playSound(name: keyof typeof soundSprites, volume = 1.0) {
    if (!isTouched || isMuted)
        return;

    try {
        const soundId = sounds.play(name);
        if (volume < 1) {
            sounds.volume(volume, soundId);
        }
    }
    catch (error) {
        const store = getStore();
        store && store.dispatch(trackError({
            category: "playSound",
            message: "Failed to play sound sprite",
            error: error,
            data: {
                sprite: name,
                volume
            }
        }))
    }
}